export default function getUniqueValues(originalArray) {
  return originalArray.sort().filter((item, pos, arr) => {
    return !pos || item !== arr[pos - 1];
  });
}
